export const EntityTypeUrlParam = "code";